function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M290.976 8.36967L310.524 33.8981L282.945 41.6089L290.976 8.36967Z",
  fill: "#ED3E3E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M320.24 2.39014L330 43.6363L317.637 31.4589L307.064 29.2984L299.256 19.2814L320.24 2.39014Z",
  fill: "#ED3E3E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M278.848 0.862549L288.135 21.9389L284.225 36.3801L272.004 28.1837H243L278.848 0.862549Z",
  fill: "#ED3E3E"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 29.0146,
  height: 1.94213,
  transform: "matrix(0.972932 -0.231093 0.164231 0.986422 283.229 41.094)",
  fill: "#ED3E3E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M291.079 30.0786C291.079 30.6059 290.786 31.0333 290.425 31.0333C290.063 31.0333 289.771 30.6059 289.771 30.0786C289.771 29.5512 290.063 29.1238 290.425 29.1238C290.786 29.1238 291.079 29.5512 291.079 30.0786Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 298.274,
  cy: 27.2143,
  rx: 0.654135,
  ry: 0.763818,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 295.004,
  cy: 30.0786,
  rx: 0.654135,
  ry: 0.954773,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 302.526,
  cy: 31.0333,
  rx: 0.654135,
  ry: 0.763818,
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.733,
  cy: 34.4706,
  rx: 0.654135,
  ry: 0.763818,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 297.948,
  cy: 31.0333,
  rx: 0.654135,
  ry: 0.763818,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 289.117,
  cy: 34.4706,
  rx: 0.654135,
  ry: 0.763818,
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  x1: 333,
  y1: 24.5,
  x2: 568,
  y2: 24.5,
  stroke: "#ED3E3E",
  strokeWidth: 3
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  y1: 24.5,
  x2: 235,
  y2: 24.5,
  stroke: "#ED3E3E",
  strokeWidth: 3
});

function SvgSpacer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 52,
    viewBox: "0 0 568 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacer);
export default __webpack_public_path__ + "static/media/spacer.5fcc26c6.svg";
export { ForwardRef as ReactComponent };